import { render, staticRenderFns } from "./DashLtvBlock.vue?vue&type=template&id=9c61923a"
import script from "./DashLtvBlock.vue?vue&type=script&lang=js"
export * from "./DashLtvBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports